// <cutoff-countdown>: "Order in the next 4h 12m for tomorrow". Text pieces come from the element itself,
// so the announcement bar and product page share one implementation with their own wording.

import { msUntilCutoff, buildCalendar, formatCountdown } from '@theme/dates';

class CutoffCountdown extends HTMLElement {
  connectedCallback() {
    this.tick();
    this.timer = setInterval(() => this.tick(), 30_000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const settings = window.theme?.delivery || {};
    // After today's cut-off, count down to tomorrow's; the day shown is the first one that's open.
    const ms = msUntilCutoff(settings);
    const first = buildCalendar(settings).find((d) => !d.disabled);
    const day = !first ? 'your chosen day' : first.label === 'Today' ? 'today' : first.label === 'Tmrw' ? 'tomorrow' : first.weekday;
    const time = this.querySelector('[data-time]');
    const when = this.querySelector('[data-day]');
    if (time) time.textContent = formatCountdown(ms);
    if (when) when.textContent = day;
  }
}

customElements.define('cutoff-countdown', CutoffCountdown);
